export function isObject(a) {
  return a && typeof a === 'object' && !Array.isArray(a);
}

export function stableStringifyReplacer(_, value) {
  return isObject(value)
    ? Object.assign(
        {},
        ...Object.keys(value)
          .sort()
          .map((key) => ({
            [key]: value[key],
          }))
      )
    : value;
}

export function stableStringify(obj) {
  return JSON.stringify(obj, stableStringifyReplacer);
}

export function isPrimitive(val) {
  return val !== Object(val);
}
